import { SocialMediaItem } from './SocialMediaButtons.types';
import {
  buildMailtoUrl,
  buildSmsUrl,
  buildWhatsappUrl,
} from './SocialMediaButtons.utils';

export const ICON_SIZE = 28;
export const TILE_H = 63;
export const ICON_ROW_H = 32;
export const LABEL_ROW_H = 20;

export const socialMediaData: SocialMediaItem[] = [
  {
    name: 'whatsUp',
    getLink: (url: string) => buildWhatsappUrl(url),
    text: 'WhatsApp',
  },
  {
    name: 'sms',
    getLink: (url: string) => buildSmsUrl(url),
    text: 'Text',
  },
  {
    name: 'email',
    getLink: (url: string) => buildMailtoUrl(url),
    text: 'Email',
  },
];
